import { Button } from '@uhg-abyss/web/ui/Button';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import { portalNameThemeMap } from '@uhg-psx/theme-utils';
import { find } from 'lodash';
import { useTranslation } from 'react-i18next';

import { ClientNames, Constants } from './../../../common/Constants';
import { ConstantsLagoon } from '../../../common/ConstantsLagoon';
import { StyledFooterAlignRight } from '../../../common/ConstantsStyles';
import { PortalIdentifier } from '../../../common/Portal';
import { useLagoon } from '../../../hooks/useLagoon';

type Props = {
  handleClose: (isClose?: boolean) => void;
  handleLogin: () => void;
};

export const GuestTimeoutModal = ({ handleClose, handleLogin }: Props) => {
  const { t } = useTranslation();
  const clientName = sessionStorage.getItem(
    Constants.STORAGE_KEYS.SESSION.CLIENT_NAME
  );
  const isGehaOrUmrGuest =
    clientName?.toLowerCase() === ClientNames.GEHA ||
    clientName?.toUpperCase() === ClientNames.UMR;

  const data = useLagoon('ui-messaging')();

  const guestTimeoutModalBodyText = find(data, {
    key: ConstantsLagoon.GUEST_PLAN_SELECTION.GUEST_TIMEOUT_MODAL_BODY,
  })?.message;

  const gehaGuestTimeoutModalBodyText = find(data, {
    key: ConstantsLagoon.GUEST_PLAN_SELECTION.GEHA_GUEST_TIMEOUT_MODAL_BODY,
  })?.message;

  return (
    <ModalDialog
      closeOnClickOutside={false}
      css={{
        'abyss-modal-base-header-container': {
          padding: '16px',
        },
        ...(clientName?.toLowerCase() === ClientNames.GEHA && {
          'abyss-modal-base-header': {
            color: `${
              portalNameThemeMap[PortalIdentifier.GEHA]?.v2?.primaryColor
            } !important`,
          },
        }),
      }}
      data-auto-testid="guest-timeout-modal"
      data-testid="guest-timeout-modal"
      footer={
        <StyledFooterAlignRight>
          <Layout.Group style={{ gap: 8 }}>
            <Button
              css={
                clientName?.toLowerCase() === ClientNames.GEHA && {
                  backgroundColor: `${
                    portalNameThemeMap[PortalIdentifier.GEHA]?.v2?.primaryColor
                  } !important`,
                  'abyss-button-content-container': {
                    color: '#FFFFFF !important',
                  },
                }
              }
              data-auto-testid="timeout-modal-start-new-session"
              data-testid="timeout-modal-start-new-session"
              onClick={() => handleClose(false)}
            >
              {t('INACTIVITY_MODAL.START_NEW_SESSION')}
            </Button>
            {!isGehaOrUmrGuest && (
              <Button
                data-auto-testid="timeout-modal-sign-in"
                data-testid="timeout-modal-sign-in"
                onClick={handleLogin}
                variant="outline"
              >
                {t('INACTIVITY_MODAL.SIGN_IN')}
              </Button>
            )}
          </Layout.Group>
        </StyledFooterAlignRight>
      }
      header={t('INACTIVITY_MODAL.TITLE_SESSION_ENDED')}
      isOpen
      onClose={() => handleClose(true)}
    >
      {isGehaOrUmrGuest
        ? gehaGuestTimeoutModalBodyText
        : guestTimeoutModalBodyText}
    </ModalDialog>
  );
};
